import React from 'react'
import { observer } from 'mobx-react'

import styles from './key.scss'

interface IProps {
  type: string
}

const Key = ({ type }: IProps) => (
  <div data-cy="shortcuts-key" className={styles.container}>
    {type}
  </div>
)

export default observer(Key)
